import { render, staticRenderFns } from "./TripFromArrived.vue?vue&type=template&id=181e1d6a&"
import script from "./TripFromArrived.vue?vue&type=script&lang=ts&"
export * from "./TripFromArrived.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports